import axiosInstance from '@core/utils/axiosInstance';
import type { Order } from './order';
import type { ProductionItem } from './productionItems';

export interface DashboardKpiSummary {
  newOrders: number;
  openOrders: number;
  overdueOrders: number;
  readyForReleaseOrders: number;
}

export const getDashboardKpis = async (): Promise<DashboardKpiSummary> => {
  const { data } =
    await axiosInstance.get<DashboardKpiSummary>('/dashboard/kpis');
  return data;
};

export type DashboardProductionNeedsAttentionItem = Omit<
  ProductionItem,
  'order'
> & {
  order: Pick<Order, 'id' | 'customer' | 'status' | 'dueDate'>;
};

export const getProductionNeedsAttentionItems = async (): Promise<
  DashboardProductionNeedsAttentionItem[]
> => {
  const { data } = await axiosInstance.get<
    DashboardProductionNeedsAttentionItem[]
  >('/dashboard/production-needs-attention');
  return data;
};
